import React from 'react';
import { Button, CircularProgress, Grid, Stack } from '@mui/material';

interface FormSubmitButtonProps {
  isValid: boolean;
  isSaving: boolean;
  onSave: () => void;
  savingText?: string;
  submitText?: string;
  disabled?: boolean;
}

export const FormSubmitButton: React.FC<FormSubmitButtonProps> = ({
  isValid,
  isSaving,
  onSave,
  savingText = 'Saving...',
  submitText = 'Save',
  disabled = false,
}) => {
  return (
    <Grid item xs={12}>
      <Stack direction="row" justifyContent="flex-end" mt={3.75}>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={!isValid || isSaving || disabled}
          startIcon={isSaving ? <CircularProgress size={16} /> : null}
        >
          {isSaving ? savingText : submitText}
        </Button>
      </Stack>
    </Grid>
  );
};

